<template>
  <div>
    <van-popup v-model="visible" position="bottom">
      <div class="repayment-select">
        <img
          class="close"
          src="https://static.ndmicro.com/tmd/landing/images/btn_close.png"
          srcset="
                    https://static.ndmicro.com/tmd/landing/images/btn_close@2x.png 2x,
                    https://static.ndmicro.com/tmd/landing/images/btn_close@3x.png 3x
                "
          @click="close"
        />
        <div class="panel">
          <div class="cell-title">
            <span v-if="canConsultRepay">申请展期</span> <span v-else>还款</span>总额 (元)
            <span style="font-family: DIN-Medium,DIN;">{{
              totalAmount | currency
            }}</span>
          </div>

          <div class="term-list">
            <table width="100%">
              <tr class="table-header">
                <th width="5%"></th>
                <th width="25%">还款日</th>
                <th width="15%">期数</th>
                <th width="20%">应还金额</th>
                <th width="20%">剩余应还</th>
                <th width="15%">状态</th>
              </tr>

              <tr
                class="table-row"
                v-for="(item, index) in canRepayList"
                :key="index"
                @click="selectTerm(index, item)"
              >
                <td>
                  <div
                    :class="[
                      'select',
                      selectedTerm.includes(index) &&
                        'selected',
                      !item.termCanRepay && 'disabled',
                    ]"
                  >
                  </div>
                </td>
                <td>
                  {{ item.repaymentDueDate | date('YYYY/MM/DD') }}
                </td>
                <td>
                  {{ item.repaymentIndex }}/{{
                    scheduleList.length
                  }}期
                </td>
                <td>
                  <div>
                    <span>{{
                      item.schdAmt | currency
                    }}</span>
                  </div>
                </td>

                <td class="amount">
                  <div class="amount-wrapper">
                    <span>{{
                      item.repaymentDueTotal | currency
                    }}</span>
                    <span
                      class="wavamount"
                      v-if="item.hasWav"
                    >{{
                      item.beforWavAmount | currency
                    }}</span>
                  </div>
                </td>
                <td
                  class="status"
                  :class="item.termStatus.toLowerCase()"
                >
                  {{ item.termStatus | status }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="footer">
          <nd-button
            :disabled="selectedTerm.length === 0"
            @click="goRepayment"
          >下一步</nd-button>
        </div>
      </div>
    </van-popup>
    <nd-dialog
      v-model="svipDialog"
      :footer="false"
      closeBtn
      isShowBg
      class="dialog"
    >
      <svip-dialog @close="svipDialog=false" :svipData="svipData" @next="jump" @judgeOrder="judgeOrder"/>
    </nd-dialog>
    <nd-dialog
      v-model="payDialog"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <pay-dialog @close="payDialog=false" @jumpMiddle="jumpMiddle" :payStatusInfo="payStatusInfo"/>
    </nd-dialog>
    <bvip-pay-dialog v-model="consumVisible" :repayBillNo="consumptionBillNo"
                     :consumptionRepayPop="consumptionRepayPop"
    ></bvip-pay-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getKey, setKey } from '@/assets/utils'
import payDialog from '@/components/withdraw-mao/payDialog.vue'
import svipDialog from './svipDialog'
import qs from 'qs'
import BvipPayDialog from './bvip-pay-dialog.vue'

export default {
  name: 'repayment-select',
  customReadyNotify: true,
  props: {
    scheduleList: { type: Array, default: () => [] },
    loanPlatform: { type: String },
    orderId: { type: String },
    fundCode: { type: String },
    productCd: { type: String },
    canOffLineRepay: { type: Boolean, default: true },
    termNo: { type: Number },
    canOnlyRepayAll: { type: Boolean, default: true },
    canConsultRepay: { type: Boolean, default: false }
  },
  components: {
    svipDialog,
    payDialog,
    BvipPayDialog
  },
  data () {
    return {
      consumptionRepayPop: '',
      consumVisible: false, // 需要先还消费账单的弹窗
      consumptionBillNo: '', // 消费账单的账单号
      visible: false,
      selectedTerm: [],
      overdueVisible: false,
      prepayVisible: false,
      popItem: {},
      svipDialog: false,
      svipData: {},
      payDialog: false,
      payStatusInfo: {},
      pending: false
    }
  },

  filters: {
    status (value) {
      const mapping = {
        U: '待还',
        O: '逾期',
        S: '已还款',
        J: '还款中',
        R: '对账中'
      }
      return mapping[value]
    }
  },

  computed: {
    totalAmount () {
      return this.selectedTerm.reduce(
        (a, b) => a + this.canRepayList[b].repaymentDueTotal,
        0
      )
    },

    // 逾期列表
    overdueList () {
      return this.scheduleList.filter(item => item.termStatus === 'O')
    },

    // 可选列表
    canRepayList () {
      return this.scheduleList.filter(item => item.termCanRepay)
    },

    // 必须选择的列表
    mustRepayList () {
      return this.scheduleList.filter(item => item.termMustRepay)
    },

    // 默认选择列表
    defaultRepayList () {
      if (this.overdueList.length === 0) {
        return this.canRepayList.filter((item, idx) => (idx === 0 && item.repaymentIndex === this.termNo) || item.termMustRepay)
      }
      return this.canRepayList.filter(item => item.termMustRepay || (item.termStatus === 'O' && item.termCanRepay))
    }
  },

  watch: {
    defaultRepayList () {
      this.defaultRepayList.forEach((item, idx) => {
        if (this.selectedTerm.includes(idx)) return
        this.selectedTerm.push(idx) 
      }) 
    }
  },
  destroyed () {
    this.$storage.remove('repaySvipDialog')
  },
  methods: {
    ...mapActions('repay', ['getRepayTrialX', 'svipLoanPopup']),
    ...mapActions('vip', [
      'orderList'
    ]),
    open () {
      this.$report({
        id: 10108,
        args: {
          visible: 1
        }
      })
      this.visible = true
    },
    // 是否有已存在订单
    async judgeOrder () {
      this.$report({
        id: 10275,
        args: {
          status: 'gou_mai',
          step: this.status
        }
      })
      this.svipDialog = false
      const res = await this.orderList({ Status: '' })
      if (res.success) {
        let payStatusInfo = res.data || {}
        if (
          payStatusInfo &&
          payStatusInfo.payStatus &&
          payStatusInfo.payStatus === 'WAIT_PAY'
        ) {
          this.payStatusInfo = payStatusInfo || {}
          this.payDialog = true
        } else {
          this.jumpMiddle()
        }
      }
    },
    // 跳转到收银台
    jumpMiddle (modeOfPayment) {
      let discountPriceValue = ''
      let mode = {}
      let goods = ''
      if (modeOfPayment === 'continue') {
        const { originalAmount, couponUseDetail, reducedAmount, goodsCd } = this.payStatusInfo || {}
        discountPriceValue = originalAmount
        goods = goodsCd
        mode = { couponUseDetail: JSON.stringify(couponUseDetail), modeType: 'continue', reducedAmount }
      }
      let host = encodeURIComponent(window.location.href)
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let device = this.getDevice()
      const { discountPrice, memberGoodsGroupCd, memberGoodsCd } = this.svipData || {}
      const origin = process.env.VUE_APP_PAYURL
      const channel = getKey('channel') || ''
      const path = '/pay'
      const query = {
        host,
        gid,
        token,
        channel,
        device,
        modeType: modeOfPayment,
        discountPrice: discountPriceValue || discountPrice,
        memberType: goods || memberGoodsCd,
        memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
        status: this.status,
        ...mode
      }
      window.location.href = `${origin}${path}?${qs.stringify(query)}&refurl=${window.location.origin}`
      // this.$router.push(
      //   { path: '/vip/middle',
      //     query: {
      //       host,
      //       gid,
      //       token,
      //       device,
      //       modeType: modeOfPayment,
      //       discountPrice: discountPriceValue || discountPrice,
      //       memberType: goods || memberGoodsCd,
      //       memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
      //       status: this.status,
      //       ...mode
      //     } 
      //   }
      // )
    },
    close () {
      this.$report({
        id: 10108,
        args: {
          visible: 0
        }
      })
      this.$report({
        id: 10109
      })
      this.visible = false
    },

    getRepayTrial () {
      const params = {
        loanPlatform: this.loanPlatform,
        orderId: this.orderId,
        terms: this.selectedTerm.map((item) => {
          return {
            termNo: this.canRepayList[item].repaymentIndex,
            overdays: this.canRepayList[item].overdueDays
          }
        }),
        fundCode: this.fundCode,
        repayScene: this.canConsultRepay ? 'CONSULT_REPAYMENT' : ''
      }
      return this.getRepayTrialX(params)
    },

    // 选择期数
    selectTerm (index, term) {
      // 如果当期不可选，直接返回
      if (!term.termCanRepay || term.termMustRepay) return
      const canList = []
      this.canRepayList.map((item, idx) => {
        if (!this.selectedTerm.includes(idx) && item.termCanRepay) {
          canList.push(idx)
        }
      })
      // canOnlyRepayAll 'true' 代表只能提前结清
      if (this.selectedTerm.includes(index)) {
        // 如果取消的不是当期，并且只支持提前结清，如果没有逾期, 那么就默认选中当期
        if (
          term.repaymentIndex > this.termNo &&
          this.canOnlyRepayAll
        ) {
          this.selectAll()
        } else {
          if (Math.max(...this.selectedTerm) === index) {
            this.toggle(this.selectedTerm, index)
          } else {
            this.$message('请顺次选择还款期数')
          }
        }
      } else {
        // 如果选择的不是当期，并且只支持提前结清，那就直接全选
        // console.log(term, this.termNo, this.canOnlyRepayAll)
        if (
          term.repaymentIndex > this.termNo &&
          this.canOnlyRepayAll
        ) {
          this.selectAll()
          this.$message('根据借款方要求，当前仅支持提前整笔结清')
        } else {
          if (Math.min(...canList) === index) {
            this.toggle(this.selectedTerm, index)
          } else {
            this.$message('请顺次选择还款期数')
          }
        }
      }
      this.$report({
        id: 10030,
        args: {
          position: this.loanPlatform,
          target: this.selectedTerm
            .map((idx) => this.canRepayList[idx].repaymentIndex)
            .join(',')
        }
      })
    },

    toggle (arr, i) {
      const index = arr.indexOf(i)
      if (index === -1) {
        arr.push(i)
      } else {
        arr.splice(index, 1)
      }
      return arr
    },

    selectAll () {
      if (this.selectedTerm.length === this.canRepayList.length) {
        const selectedTerm = []
        const defaultRepaymentIndex = this.defaultRepayList.map(item => item.repaymentIndex)
        this.canRepayList.map((item, idx) => {
          if (defaultRepaymentIndex.includes(item.repaymentIndex)) {
            selectedTerm.push(idx)
          }
        })

        this.selectedTerm = selectedTerm
      } else {
        this.selectedTerm = this.canRepayList.map((item, idx) => idx)
      }
    },

    // 查看逾期还款详情
    overdueRepaymentInfo (item) {
      this.popItem = item
      this.overdueVisible = true
    },

    async goRepayment () {
      if (this.pending) return
      this.pending = true
      if (!getKey('repaySvipDialog') && !this.canConsultRepay) {
        let res = await this.svipLoanPopup({ billNo: this.orderId })
        if (res.success && res.data) {
          this.svipData = res.data || {}
          this.visible = false
          this.svipDialog = true
          this.$report({
            id: 10406
          })
          setKey('repaySvipDialog', true)
        } else {
          this.jump()
        }
      } else {
        this.jump()
      }
      setTimeout(() => {
        this.pending = false
      }, 300)
    },
    async jump () {
      this.$storage.set(
        'selectedTerms',
        this.selectedTerm.map((item) => this.canRepayList[item])
      )
      const response = await this.getRepayTrial()
      if (response.success) {
        this.$storage.set('trail', response.data)
        if (this.canConsultRepay) {
          this.$router.push({
            path: '/repayment/consult',
            query: {
              orderId: this.orderId,
              loanPlatform: this.loanPlatform
            }
          })
        } else {
          if (response.data.beforeRepayConsumptionBill) {
            const { consumptionBillNo, consumptionRepayPop } = response.data
            this.consumptionBillNo = consumptionBillNo
            this.consumVisible = true
            this.visible = false
            this.consumptionRepayPop = consumptionRepayPop
            return
          }
          this.$router.push({
            path: '/repayment/confirm/tmd',
            query: {
              orderId: this.orderId,
              loanPlatform: this.loanPlatform,
              fundCode: this.fundCode, 
              productCd: this.productCd, 
              canOffLineRepay: this.canOffLineRepay ? 'T' : 'F',
              termId: this.canRepayList[this.selectedTerm[0]].termId
            }
          })
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.van-popup {
    background-color: transparent;
}
.repayment-select {
    position: relative;
    background-color: #fff;
    border-radius: 30px 30px 0 0;
    .close {
        position: absolute;
        width: 33px;
        height: 33px;
        top: 60px;
        right: 50px;
    }

    .panel {
        padding: 0 30px;
        overflow: hidden;

        .cell-title {
            font-size: 32px;
            margin-top: 60px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            line-height: 50px;
        }

        .term-list {
            margin-top: 83px;
            height: 768px;
            overflow-y: scroll;
            table {
                width: 100%;
                border-spacing: 0px;

                .table-header {
                    th {
                        font-size: 26px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(102, 102, 102, 1);
                        line-height: 50px;
                    }
                }

                .table-row {
                    td {
                        height: 110px;
                        line-height: 110px;
                        font-size: 26px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        text-align: center;
                        vertical-align: middle;

                        .select {
                            width: 32px;
                            height: 32px;
                            background-size: cover;
                            background-image: url(../images/unselected.png);

                            &.selected {
                                background-image: url(../images/selected.png);
                            }

                            &.disabled {
                                background-image: none;
                                background-color: #dddddd;
                                border-radius: 32px;
                            }
                        }
                    }

                    .status {
                        &.o {
                            color: @fc-error;
                        }
                    }

                    & + .table-row {
                        td {
                            padding-top: 2px;
                        }
                    }

                    .amount {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;

                        .amount-wrapper {
                            position: relative;

                            .wavamount {
                                transform: translate3d(-50%, -50%, 0);
                                position: absolute;
                                top: 80%;
                                left: 50%;
                                text-decoration: line-through;
                                color: @fc4;
                            }
                        }

                        img {
                            width: 23px;
                            height: 23px;
                            margin-left: 5px;
                        }
                    }
                }
            }
        }
    }

    .footer {
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.04);
        overflow: hidden;
        > button {
            display: block;
            margin: 30px auto 58px;
        }
    }

    .overdue-repayemnt-info,
    .prepay-rule {
        padding: 0 45px;
        padding-bottom: 37px;

        .title {
            height: 72px;
            line-height: 72px;
            font-size: 42px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
        }

        .divide {
            height: 32px;
            line-height: 32px;
            font-size: 28px;
            margin-top: 23px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
        }

        .amount {
            font-size: 32px;
            height: 32px;
            line-height: 32px;
            margin-top: 27px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: @fc1;

            &.overdue {
                color: @theme;
            }

            em {
                font-size: 22px;
                padding-left: 10px;
                display: inline-block;
                font-style: normal;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: @fc4;
                text-decoration: line-through;
            }
        }

        .explain {
            font-size: 22px;
            height: 44px;
            line-height: 44px;
            margin-top: 3px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: @fc4;
            text-align: left;
        }

        .principal,
        .interest {
            margin-top: 15px;
            height: 40px;
            line-height: 40px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
        }

        p {
            font-size: 24px;
            line-height: 33px;
            margin-top: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
        }
    }
}
</style>